module.exports = __webpack_public_path__ + "img/tarjeta_beneficios_talleres_calidad.63ac3498.jpg";